import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var recommerceLikeNewIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5 3.06a7 7 0 0 0-9.9 0 7.08 7.08 0 0 0 0 10l2.7 2.73.36-.36a1 1 0 0 0 0-1.41l-1.9-1.91a5.69 5.69 0 0 1-.58-7.5 5.48 5.48 0 0 1 8.64 0 5.69 5.69 0 0 1-.58 7.5l-3.66 3.68L10.36 17l-.79.79a3 3 0 0 0-.26 4.05 2.88 2.88 0 0 0 4.19.16 2.9 2.9 0 0 0 .78-2.6 1 1 0 0 0-1.58-.63l-.2.23a1.42 1.42 0 0 1 0 2 1.38 1.38 0 0 1-2 0 1.41 1.41 0 0 1 0-2l6-6a7.08 7.08 0 0 0 0-9.94Z",
  fill: "currentColor"
}));

export { recommerceLikeNewIcon as default };
//# sourceMappingURL=recommerceLikeNewIcon.js.map
